import React, { useState, useMemo, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Pagination from '@mui/material/Pagination';


import Terex from "./../../assets/projects/terax/terax3d (2).webp" ;
import Kayjay from "./../../assets/projects/kayjay/kayjay3d (4).webp" ;
import Inframat from "./../../assets/Industries/inframat factory unit/factory view3.webp" ;
import Dyna from "./../../assets/Industries/dynaspeed/91e9c00b-89bd-47f9-8491-96dfb456d09e-01.jpeg" ;
import Asr from "./../../assets/projects/residence/APF02613.webp"; 
import Relax from "./../../assets/projects/relaxinn/resort 1 (1).webp" ;
import Ephephany from "./../../assets/projects/ephepany/mahal (2).webp" ;
import Infant from "./../../assets/projects/church1/WhatsApp Image 2025-03-01 at 10.52.02 AM.webp" ;
import Poondi from "./../../assets/projects/church 2/Poondi Madha church _page-0002.webp" ;
import Churchhall from "./../../assets/Chruch Webp/churchconferencehall/Church-view-4-24-06-2024.webp" ;
import Pius from "./../../assets/Chruch Webp/St. Pius Thirumandhurai Church/Immagine 068.jpg" ;
import Sebastian from "./../../assets/Chruch Webp/St. Sebastian poolapatti dharmapuri/2. FINAL FRONT VIEW.jpeg" ;
import Orthodox from "./../../assets/Chruch Webp/orthodoxchurch/IMG_6579.webp" ;
import Lourdes from "./../../assets/Chruch Webp/st.lourdes-hosur/DSC_0054.webp" ;
import Anthony from "./../../assets/Chruch Webp/st.anthony/OP-4_Photo - 7 (2).webp" ;
import Ivdp from "./../../assets/Industries/IVDP Office building/front view 02.jpg" ;
import Ivdpshg from "./../../assets/Industries/ivdpnew/WhatsApp Image 2025-05-03 at 11.32.10 AM.jpeg" ;
import Amala from "./../../assets/Schools/Amala School -  Dharmapuri/124563.jpg" ;
import Shuttle from "./../../assets/Comercial/Shuttle court/Actual side View.jpeg" ;
import Lake from "./../../assets/Comercial/Hosur ramanayakan lake walkers lane meditation hall/3D Front View.jpg" ;
import Edward from "./../../assets/residential/Edward Sundar/edward (1).webp" ;
import Muni from "./../../assets/residential/Mr.Munirathinam/photo (1).webp" ;
import Venkat from "./../../assets/residential/Mr.Venkatesh - Hosur/OP -1_Photo - 1.webp" ;
import Carmel from "./../../assets/Retreat Center/Carmelretreatcenter/Carmel-divine- Elevation 02.01.2017-FINAL.webp" ;
import Donbosco from "./../../assets/Retreat Center/DonBosco/A3 - 1.webp" ;
import Casata from "./../../assets/Comercial/Yercaudhotel/Hotel project at Yercaud.webp" ;
import Manju from "./../../assets/Comercial/Majunatha theater/Sree Manjunatha Theatre.jpg";
import Csi from "./../../assets/Schools/csi.jpg";
import Bharadhi from "./../../assets/Schools/Website.webp";
import Thiru from "./../../assets/Industries/dynaspeed/images-01.jpeg";

import Res1 from "./../../assets/residential/Abraham house/abraham 4.jpg" ;
import Res2 from "./../../assets/residential/Mary prabha/mary prabha 3d .jpg" ;
import Res3 from "./../../assets/residential/Mr. Jerome surya/Mr.Jerome -01-07-2024.jpg" ;
import Res4 from "./../../assets/residential/Mr. Kumar - Salem/Mr. Kumar - Salem.jpg" ;
import Res5 from "./../../assets/residential/Mr. Murugappan- hosur/Mr. Murugappan - Hosur 3d.jpg" ;
import Res6 from "./../../assets/residential/Mr. Sathyamuruthy - Hosur/Mr.Sathiamurthy_s  Residential Building3d.jpg" ;
import Res7 from "./../../assets/residential/Mr. William - Hosur/FINAL.jpg" ;
import Res8 from "./../../assets/residential/Mr. baliga bangalore/3D.jpg" ;
import Res9 from "./../../assets/residential/Mr. hermant/06.12.2019_FINAL FRONT VIEW.jpg" ;
import Res10 from "./../../assets/residential/Mr. kesavan - Hosur/Mr. Kesavan - Hosur.jpg" ;
import Res11 from "./../../assets/residential/Mr.Narayanan - Krishnagiri/Mr.Narayanan - option 2 - 18.09.2019.jpg" ;
import Res12 from "./../../assets/residential/Priya vinoth/priya vinoth 3d.jpg" ;
import Res13 from "./../../assets/projects/residence/actual (22).webp" ;
import  Heucharist from "./../../assets/Chruch Webp/Holy Eucharist Bommanahalli Bangalore/elevation (2).jpg"

// TEREX
import Img21 from "./../../assets/Industries/terex/maindining (1).webp";
import Img22 from "./../../assets/Industries/terex/maindining (2).webp";
import Img24 from "./../../assets/Industries/terex/maindining (3).webp";
import Img23 from "./../../assets/Industries/terex/maindining (4).webp";
import Img25 from "./../../assets/Industries/terex/maindining (5).webp";

// TERAX
import Img19 from "./../../assets/projects/terax/terax3d (9).webp";
import Img20 from "./../../assets/projects/terax/terax3d (10).webp";

// RESIDENCE
import Img28 from "./../../assets/projects/residence/3d (1).webp";
import Img29 from "./../../assets/projects/residence/3d (2).webp";
import Img30 from "./../../assets/projects/residence/3d (3).webp";
import Img31 from "./../../assets/projects/residence/3d (4).webp";
import Img32 from "./../../assets/projects/residence/3d (5).webp";
import Img33 from "./../../assets/projects/residence/res3d.webp";
import Img34 from "./../../assets/projects/residence/3d (7).webp";
import Img35 from "./../../assets/projects/residence/3d (8).webp";


import Img001 from "./../../assets/projects/residence/actual (1).webp";
import Img002 from "./../../assets/projects/residence/actual (2).webp";
import Img003 from "./../../assets/projects/residence/actual (3).webp";
import Img004 from "./../../assets/projects/residence/actual (4).webp";
import Img005 from "./../../assets/projects/residence/actual (5).webp";
import Img006 from "./../../assets/projects/residence/actual (6).webp";
import Img007 from "./../../assets/projects/residence/actual (7).webp";
import Img008 from "./../../assets/projects/residence/actual (8).webp";
import Img009 from "./../../assets/projects/residence/actual (9).webp";
import Img010 from "./../../assets/projects/residence/actual (11).webp";
import Img011 from "./../../assets/projects/residence/actual (12).webp";
import Img012 from "./../../assets/projects/residence/actual (14).webp";
import Img013 from "./../../assets/projects/residence/actual (15).webp";
import Img014 from "./../../assets/projects/residence/actual (16).webp";
import Img015 from "./../../assets/projects/residence/actual (18).webp";
import Img016 from "./../../assets/projects/residence/actual (19).webp";
import Img017 from "./../../assets/projects/residence/actual (21).webp";
import Img018 from "./../../assets/projects/residence/actual (23).webp";
import Img019 from "./../../assets/projects/residence/actual (25).webp";
import Img020 from "./../../assets/projects/residence/actual (27).webp";


// ELAGIRI RESORT
// import Img1R from "./../../assets/Comercial/Elagiri Resort/yelagiriresort (1).webp";
import Img2R from "./../../assets/Comercial/Elagiri Resort/yelagiriresort (1).jpeg";

import Img6R from "./../../assets/Comercial/Elagiri Resort/yelagiriresort (5).jpeg";


const App = () => {
  const navigate = useNavigate();

  const PAGE_SIZE = 10;

  const topics = ['All', 'Industrial', 'Residential', 'Commercial', 'Church','Interiors','Institutions','Ongoing'];

  const allProjects = [
    { title: 'Terex India Private Limited, Hosur', imageUrl: Terex, topic: 'Industrial', link: '/terexindia' },
    { title: 'Kay Jay Forgings Private Limited, Hosur',  imageUrl: Kayjay, topic: 'Industrial', link: '/kayjayforgingsprivatelimited' },
    { title: 'Inframat Factory Unit, Shoolagiri',  imageUrl: Inframat, topic: 'Industrial', link: '/inframatfactoryunit' },
    { title: 'Dynaspede Integrated Systems Private Limited, Hosur', imageUrl: Dyna, topic: 'Industrial' },
    { title: 'Mr.Kumar Residence, Hosur',  imageUrl: Res4, topic: 'Residential', link: '/asr2' },
    { title: 'ASR Resdience, RK Avenue, Hosur',  imageUrl: Asr, topic: 'Residential', link: '/asrresidence' },
    { title: 'Mr.Edward Sundar Residence, Hosur ',  imageUrl: Edward, topic: 'Residential',  link: '/mr.edwardresident' },
    { title: 'Mr.Munirathnam Residence, Hosur',  imageUrl: Muni, topic: 'Residential',  link: '/mr.munirathnamresident' },
    { title: 'Mr.Sam Residence, Elathigiri',  imageUrl: Res13, topic: 'Residential', link: '/samresidence'  },
    { title: 'Mr.Venkatesh Residence, Hosur',  imageUrl: Venkat, topic: 'Residential',  link: '/mr.venkateshresident' },
    { title: 'Relax inn resort, Yelagiri',  imageUrl: Relax, topic: 'Commercial', link: '/relaxinnresort' },
    { title: 'Ephephany Conventional Hall, Salem',  imageUrl: Ephephany, topic: 'Commercial', link: '/ephepanyconventionalhall' },
    { title: 'Manjunatha Theater, Hosur',  imageUrl: Manju, topic: 'Commercial', link: '/manjunathatheater' },
    { title: 'Infant Jesus Church, Selliampatti',  imageUrl: Infant, topic: 'Church', link: '/selliyampattiinfantjesuschurch' },
    { title: 'Poondi Madha Church, Rayappanur',  imageUrl: Poondi, topic: 'Church',  link: '/poondimadhachurch' },
    
    { title: 'St.Pius Thirumandhurai Church',  imageUrl: Pius, topic: 'Church',  link: '/St.PiusThirumandhuraiChurch' },
    { title: 'St.Sebastian, Poolapatti, Dharmapuri',  imageUrl: Sebastian, topic: 'Church',  link: '/St.Sebastianpoolapattidharmapuri' },
    { title: 'Orthodox Church and Mission Center, Hosur',  imageUrl: Orthodox, topic: 'Church',  link: '/OrthodoxChurchandMissionCenter-Hosur' },
    { title: 'St.Lourdes, Hosur',  imageUrl: Lourdes, topic: 'Church',  link: '/St.Lourdes-Hosur' },
    { title: 'St.Anthony Church, Billigundu',  imageUrl: Anthony, topic: 'Church',  link: '/St.AnthonychurchBilligundu' },
    { title: 'IVDP Office and Training Center, Krishnagiri',  imageUrl: Ivdp, topic: 'Commercial',  link: '/IVDPoffice' },
    { title: 'IVDP SHGs Industrial Training Center, Krishnagiri',  imageUrl: Ivdpshg, topic: 'Commercial',  link: '/IVDPSHGsindustrialtrainingcenter' },
    { title: 'Amala School, Dharumapuri',  imageUrl: Amala, topic: 'Institutions',  link: '/amalaschool-dharumapuri' },
    { title: 'CSI Polytechnic College, Salem',  imageUrl: Csi, topic: 'Institutions' },
    { title: 'Bharadhidasanar CBSE School, Arakonam',  imageUrl: Bharadhi, topic: 'Institutions' },
    
    
    { title: 'Shuttle Court, Hosur',  imageUrl: Shuttle, topic: 'Commercial',  link: '/shuttlecourt' },
    { title: 'Ramanayakan Lake Walkers Lane Meditation Hall, Hosur',  imageUrl: Lake, topic: 'Commercial',  link: '/Hosurramanayakanlakewalkerslanemeditationhall' },
   
    { title: 'Carmel Retreat Center, Sogathur, Dharmapuri',  imageUrl: Carmel, topic: 'Commercial',  link: '/carmelretreatcenter' },
    { title: 'Don Bosco De-addiction Centre, Jamanamardhur',  imageUrl: Donbosco, topic: 'Commercial',  link: '/donbosco' },
    { title: 'Casata Inn, Yercaud',  imageUrl: Casata, topic: 'Commercial',  link: '/casatainnyercaud' },

        // Preview-only projects (no link)
    { title: 'Tiruttani Railway Station, (Tiruttani)',  imageUrl: Thiru, topic: 'Commercial' },
    { title: 'Holy Eucharist, Bommanahalli, Bangalore',  imageUrl: Heucharist, topic: 'Church' },
    { title: 'Mr.Abraham Residence, Hosur',  imageUrl: Res1, topic: 'Residential' },
    { title: 'Mr.Anish Peter and  Mrs.Mary Prabha Residence, Bangalore ',  imageUrl: Res2, topic: 'Residential' },
    { title: 'Mr.Baliga Residence, Bangalore',  imageUrl: Res8, topic: 'Residential' },
    { title: 'Mr.Hermant Residence, Hosur',  imageUrl: Res9, topic: 'Residential' },
    { title: 'Mr.Jerome Surya Residence, Krishnagiri',  imageUrl: Res3, topic: 'Residential' },
    { title: 'Mr.Kesavan Residence, Hosur',  imageUrl: Res10, topic: 'Residential' },
    // { title: 'Mr.Kumar, Salem',  imageUrl: Res4, topic: 'Residential' },
    { title: 'Mr.Murugappan Residence, Hosur',  imageUrl: Res5, topic: 'Residential' },
    { title: 'Mr.Sathyamuruthy Residence, Hosur',  imageUrl: Res6, topic: 'Residential' },
    { title: 'Mr.William Residence, Hosur',  imageUrl: Res7, topic: 'Residential' },
    { title: 'Mr.Narayanan Residence, Krishnagiri',  imageUrl: Res11, topic: 'Residential' },
    { title: 'Mrs.Priya Vinoth Residence, Polichalur, Chennai',  imageUrl: Res12, topic: 'Residential' },
    { title: 'Conference Hall, Sacred Heart Novitiate at Montfort Sprituality Centre, Eachinkadu, Yercaud, Salem',  imageUrl: Churchhall, topic: 'Ongoing',  link: '/ChruchConferenceHall,SacredHeartNovitiate,Eachinkadu' },


    //interiors
    { title: 'Terex Interiors 1', imageUrl: Img21, topic: 'Interiors' },
    { title: 'Terex Interiors 2', imageUrl: Img22, topic: 'Interiors' },
    { title: 'Terex Interiors 3', imageUrl: Img24, topic: 'Interiors' },
    { title: 'Terex Interiors 4', imageUrl: Img23, topic: 'Interiors' },
    { title: 'Terex Interiors 5', imageUrl: Img25, topic: 'Interiors' },
    { title: 'Terax Interiors 6', imageUrl: Img19, topic: 'Interiors' },
    { title: 'Terax Interiors 7', imageUrl: Img20, topic: 'Interiors' },
    { title: 'Residence Interior 1', imageUrl: Img28, topic: 'Interiors' },
    { title: 'Residence Interior 2', imageUrl: Img29, topic: 'Interiors' },
    { title: 'Residence Interior 3', imageUrl: Img30, topic: 'Interiors' },
    { title: 'Residence Interior 4', imageUrl: Img31, topic: 'Interiors' },
    { title: 'Residence Interior 5', imageUrl: Img32, topic: 'Interiors' },
    { title: 'Residence Interior 6', imageUrl: Img33, topic: 'Interiors' },
    { title: 'Residence Interior 7', imageUrl: Img34, topic: 'Interiors' },
    { title: 'Residence Interior 8', imageUrl: Img35, topic: 'Interiors' },
    { title: 'Residence Interior 9', imageUrl: Img001, topic: 'Interiors' },
    { title: 'Residence Interior 10', imageUrl: Img002, topic: 'Interiors' },
    { title: 'Residence Interior 11', imageUrl: Img003, topic: 'Interiors' },
    { title: 'Residence Interior 12', imageUrl: Img004, topic: 'Interiors' },
    { title: 'Residence Interior 13', imageUrl: Img005, topic: 'Interiors' },
    { title: 'Residence Interior 14', imageUrl: Img006, topic: 'Interiors' },
    { title: 'Residence Interior 15', imageUrl: Img007, topic: 'Interiors' },
    { title: 'Residence Interior 16', imageUrl: Img008, topic: 'Interiors' },
    { title: 'Residence Interior 17', imageUrl: Img009, topic: 'Interiors' },
    { title: 'Residence Interior 18', imageUrl: Img010, topic: 'Interiors' },
    { title: 'Residence Interior 19', imageUrl: Img011, topic: 'Interiors' },
    { title: 'Residence Interior 20', imageUrl: Img012, topic: 'Interiors' },
    { title: 'Residence Interior 21', imageUrl: Img013, topic: 'Interiors' },
    { title: 'Residence Interior 22', imageUrl: Img014, topic: 'Interiors' },
    { title: 'Residence Interior 23', imageUrl: Img015, topic: 'Interiors' },
    { title: 'Residence Interior 24', imageUrl: Img016, topic: 'Interiors' },
    { title: 'Residence Interior 25', imageUrl: Img017, topic: 'Interiors' },
    { title: 'Residence Interior 26', imageUrl: Img018, topic: 'Interiors' },
    { title: 'Residence Interior 27', imageUrl: Img019, topic: 'Interiors' },
    { title: 'Residence Interior 28', imageUrl: Img020, topic: 'Interiors' },
    

    
   
    { title: 'Relax Inn Resort 1', imageUrl: Img2R, topic: 'Interiors' },
    { title: 'Relax Inn Resort 5', imageUrl: Img6R, topic: 'Interiors' },
   
];


const storedPage = parseInt(sessionStorage.getItem('currentPage')) || 1;
  const storedTopic = sessionStorage.getItem('selectedTopic') || 'All';

  const [selectedTopic, setSelectedTopic] = useState(storedTopic);
  const [currentPage, setCurrentPage] = useState(storedPage);
  const [hoveredProject, setHoveredProject] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);

  // Update sessionStorage when currentPage or selectedTopic changes
  useEffect(() => {
    sessionStorage.setItem('currentPage', currentPage);
  }, [currentPage]);

  useEffect(() => {
    sessionStorage.setItem('selectedTopic', selectedTopic);
  }, [selectedTopic]);

  // Filter projects based on topic
  const filteredProjects = useMemo(() => {
    return allProjects.filter(project => {
      if (selectedTopic === 'All') {
        return project.topic !== 'Interiors';
      }
      return project.topic === selectedTopic;
    });
  }, [selectedTopic]);

  // Reset to page 1 only if topic actually changed
  useEffect(() => {
    const storedTopic = sessionStorage.getItem('selectedTopic');
    if (storedTopic !== selectedTopic) {
      setCurrentPage(1);
    }
  }, [selectedTopic]);

  // Paginate visible projects
  const paginatedProjects = useMemo(() => {
    const startIndex = (currentPage - 1) * PAGE_SIZE;
    return filteredProjects.slice(startIndex, startIndex + PAGE_SIZE);
  }, [filteredProjects, currentPage]);

  // Handle click on project
  const handleClick = (project) => {
    if (project.link) {
      navigate(project.link);
    } else {
      setPreviewImage(project.imageUrl);
    }
  };

  // Handle pagination change
  const handlePageChange = (event, value) => {
    setCurrentPage(value);

    window.scrollTo({ top: 1000, behavior: 'smooth' });
  };

  return (
    <div style={styles.container}>
      {/* Topic Filter */}
      <div style={styles.topicsContainer}>
        {topics.map((topic, index) => (
          <span
            key={index}
            style={selectedTopic === topic ? { ...styles.topic, ...styles.selectedTopic } : styles.topic}
            onClick={() => {
              setSelectedTopic(topic);
              setCurrentPage(1); // Reset page when changing topic
            }}
          >
            {topic}
          </span>
        ))}
      </div>

      {/* Project Cards */}
      <div style={styles.gridContainer}>
        {paginatedProjects.map((project, index) => (
          <div key={index} style={styles.projectCard}>
            <div
              style={styles.imageContainer}
              onMouseEnter={() => setHoveredProject(project.title)}
              onMouseLeave={() => setHoveredProject(null)}
              onClick={() => handleClick(project)}
            >
              <img
                src={project.imageUrl}
                alt={project.title}
                style={{
                  ...styles.image,
                  transform: hoveredProject === project.title ? 'scale(1.05)' : 'scale(1)',
                }}
              />
              {hoveredProject === project.title && (
                <div style={styles.overlay}>
                  <span style={styles.plusSymbol}>+</span>
                </div>
              )}
            </div>
            <div style={styles.title}>{project.title}</div>
          </div>
        ))}
      </div>

      {/* Pagination */}
      {filteredProjects.length > PAGE_SIZE && (
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 20 }}>
          <Pagination
            count={Math.ceil(filteredProjects.length / PAGE_SIZE)}
            page={currentPage}
            onChange={handlePageChange}
            color="primary"
          />
        </div>
      )}

      {/* Modal Preview */}
      {previewImage && (
        <div style={styles.modalBackdrop} onClick={() => setPreviewImage(null)}>
          <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <img src={previewImage} alt="Preview" style={styles.modalImage} />
            <button style={styles.closeButton} onClick={() => setPreviewImage(null)}>✕</button>
          </div>
        </div>
      )}
    </div>
  );
};

// Styles
const styles = {
  container: {
    padding: '20px',
  },
  topicsContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '20px',
    backgroundColor: '#111827',
    gap: '20px',
    flexWrap: 'wrap',
  },
  topic: {
    margin: '0 15px',
    fontSize: '18px',
    fontWeight: 'bold',
    cursor: 'pointer',
    color: 'white',
    padding: '10px 15px',
    borderRadius: '4px',
    transition: 'background-color 0.3s ease, color 0.3s ease',
  },
  selectedTopic: {
    backgroundColor: '#D3D3D3',
    color: '#000',
  },
  gridContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
    gap: '20px',
    justifyItems: 'center',
  },
  projectCard: {
    position: 'relative',
    width: '100%',
    textAlign: 'center',
    maxWidth: '400px',
  },
  imageContainer: {
    position: 'relative',
    width: '100%',
    height: '80%',
    overflow: 'hidden',
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'opacity 0.3s ease',
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    transition: 'transform 0.3s ease',
  },
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    transition: 'opacity 0.3s ease',
    zIndex: 1,
  },
  plusSymbol: {
    color: 'white',
    fontSize: '40px',
    fontWeight: 'bold',
  },
  title: {
    marginTop: '10px',
    fontSize: '16px',
    fontWeight: '600',
    color: '#333',
  },
  modalBackdrop: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.8)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999,
  },
  modalContent: {
    position: 'relative',
    maxWidth: '50%',
    maxHeight: '100%',
    backgroundColor: '#fff',
    borderRadius: '10px',
    overflow: 'hidden',
    boxShadow: '0 0 15px rgba(0,0,0,0.3)',
  },
  modalImage: {
    width: '100%',
    height: 'auto',
    display: 'block',
  },
  closeButton: {
    position: 'absolute',
    top: '10px',
    right: '10px',
    background: 'transparent',
    border: 'none',
    color: '#fff',
    fontSize: '24px',
    cursor: 'pointer',
  },
};

export default App;
